/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: false, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Adonay Gebremedhin",
  title: "Adonay Gebremedhin",
  subTitle: emoji(
    "Computer Engineering student and aspiring Computer Vision & Deep Learning enthusiast, exploring machine learning, LLMs, agentic systems, and robotics while building practical solutions with Python, JavaScript, and PyTorch."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/adonaydem",
  linkedin: "https://www.linkedin.com/in/adonay-gebremedhin",
  gmail: "adonay.gebremedhin@outlook.com",
  
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Get to know me",
  subTitle: "INNOVATIVE STUDENT WITH AI & SOFTWARE ENGINEERING EXPERIENCE BRIDGING MACHINE LEARNING, COMPUTER VISION, AND ROBOTICS",
  skills: [
    emoji("⚡ Researching and developing AI models for deep learning and computer vision"),
    emoji("⚡ Optimizing ML pipelines for efficient deployment and real-time performance"),
    emoji("⚡ Designing scalable backend systems with Flask and REST APIs"),
    emoji("⚡ Building full-stack applications with React, JavaScript, and Python"),
  ],


  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "PyTorch",
      fontAwesomeClassname: "fab fa-code"
    },
    {
      skillName: "Hugging Face",
      fontAwesomeClassname: "fab fa-code"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Ajman University",
      logo:  require("./assets/images/images.jpeg"),
      subHeader: "BSc in Computer Engineering",
      duration: "2023-2027",
      desc: "GPA 4.0",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, // Set to true to show Proficiency Section
  experience: [
    {
      Stack: "Machine Learning & Deep Learning (PyTorch, TensorFlow, Scikit-learn)",
      progressPercentage: "80%"
    },
    {
      Stack: "Backend/Frontend Development",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming (Python, JavaScript, C++)",
      progressPercentage: "80%"
    },
    {
      Stack: "Computer Vision & Image Processing",
      progressPercentage: "80%"
    },
    {
      Stack: "Databases (MySQL, MongoDB, SQLite)",
      progressPercentage: "80%"
    },
  ],
  displayCodersrank: false // Set true to display CodersRank badges
};


// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
  role: "Software Tech Assistant",
  company: "Ajman University Innovation Center",
  companylogo: require("./assets/images/images.jpeg"),
  date: "Dec. 2025 - Present",
  desc: "Supporting university-incubated startups by leading MVP development and providing technical support, helping early-stage teams turn ideas into functional products and accelerate progress toward launch readiness.",
},
    {
      role: "Computer Vision Intern",
      company: "Eastern Al Maha, EMCO",
      companylogo: require("./assets/images/emco.png"),
      date: "Jun. 2025 - Aug. 2025",
      desc: "Trained and deployed three computer vision models for an automated retail-shelf auditing system, ensuring brand and layout compliance and enabling real-time insights for field operations.",
  
    },


    {
      role: "Artificial Intelligence/Backend Internship",
      company: "Smallcap.ai/play2earn.ai",
      date: "Jun. 2024 – Oct. 2024",
      desc: "Led the integration team; designed and deployed NLP models with PyTorch, optimized MongoDB/MySQL for faster queries, and built Flask–React web apps to enhance performance and user engagement.",
      footerLink: [
        {
          name: "Recommendation Letter",
          url: "https://drive.google.com/file/d/1DJRbkeC3bmiDbxxVLQ35TEPfZOSfwVBD/view?usp=sharing"
        }
        //  you can add extra buttons here.
      ]    },
      
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "",
  projects: [
    {
      projectName: "Radiance",
      projectDesc: "A multimodal, AI-powered assistive platform that leverages real-time computer vision, natural language processing, and edge computing to provide environmental awareness for visually impaired users. (IEEE)",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/adonaydem/ieee_sep2025"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      projectName: "Battle of Nets",
      projectDesc: "An experimental deep learning project where modern models go head-to-head against established architectures.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/adonaydem/battle-of-nets"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      projectName: "Short Paper: Enhancing Human-AI Interaction through Multi-Agent Explainability",
      projectDesc: "SRC25, Zayed University",
  
    },
    {
      projectName: "CrewTailor @Gemini API Developer Competition (Google)",
      projectDesc: "A web platform that enables users to build no-code, multi-agent LLM systems from scratch. (React, Flask, LangChain)",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/adonaydem/CrewTailor_exp"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      projectName: "End-to-End Multi-Object Localization and Path Planning",
      projectDesc: "Object localization and path planning for autonomous robots in a grid-based environment, combining computer vision and classical algorithms in one pipeline.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://github.com/adonaydem/battle-of-nets"
        }
        //  you can add extra buttons here.
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, certifications, award letters, and some cool stuff that I have done!",

  achievementsCards: [
     {
      title: "3rd @ Khalifa University Smart Mobile App Contest",
      image: require("./assets/images/ku.png"),
      subtitle:
        "Geospatial intelligence for fully automated, scalable, and intelligent disaster management.",
      imageAlt: "",
      footerLink: [
        {
          name: "More",
          url: "https://www.linkedin.com/posts/adonay-gebremedhin_khalifauniversity-ajmanuniversity-computervison-activity-7371915852604059648-emHc?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEccgWIBv3lXwHwMStosQsR1HEZ_N8OGI7A"
        }
        //  you can add extra buttons here.
      ]

    },
     {
      title: "1st @ IEEE UAE Software Engineering Project",
      image: require("./assets/images/ieee.png"),
      subtitle:
        "A computer vision application designed to assist visually impaired users through object and scene recognition, integrated with an agentic system.",
      imageAlt: "",
      footerLink: [
        {
          name: "More",
          url: "https://www.linkedin.com/posts/adonay-gebremedhin_firstplace-ieee-softwareengineering-activity-7334918573640900608-0lmr?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEccgWIBv3lXwHwMStosQsR1HEZ_N8OGI7A"
        }
        //  you can add extra buttons here.
      ]

    },
    {
      title: "Convolutional Neural Networks",
      image: require("./assets/images/deeplearningai_logo.jpeg"),
      subtitle:
        "By Andrew Ng, DeepLearning.AI",
      imageAlt: "",
      footerLink: [
        {
          name: "Certificate Link",
          url: "https://www.coursera.org/account/accomplishments/verify/P2HBS3LH3NQJ"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      title: "Honors Assembly 2023-2024",
      subtitle:
        "Ajman University - Outstanding academic performance.",
      image: require("./assets/images/images.jpeg"),
    },{
      title: "CS50 Introduction to Artificial Intelligence",
      subtitle:
        "Harvard University",
      image: require("./assets/images/harvard.jpeg"),
      imageAlt: "",
      footerLink: [
        {
          name: "Certificate Link",
          url: "https://cs50.harvard.edu/certificates/8f642c46-c827-4ad8-9a4d-c380a2d7d50a"
        }
        //  you can add extra buttons here.
      ]
    },{
      title: "CS50 Introduction to Web Programming with Python and JavaScript",
      subtitle:
        "Harvard University",
      image: require("./assets/images/harvard.jpeg"),
      imageAlt: "",
      footerLink: [
        {
          name: "Certificate Link",
          url: "https://cs50.harvard.edu/certificates/55daa95a-bfa3-40df-bff0-c8f5e36f3acf"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  // title: "Blogs",
  // subtitle:
  //   "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  // displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  // blogs: [
  //   {
  //     url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
  //     title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
  //     description:
  //       "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
  //   },
  //   {
  //     url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
  //     title: "Why REACT is The Best?",
  //     description:
  //       "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
  //   }
  // ],
  // display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  // title: "TALKS",
  // subtitle: emoji(
  //   "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  // ),

  // talks: [
  //   {
  //     title: "Build Actions For Google Assistant",
  //     subtitle: "Codelab at GDG DevFest Karachi 2019",
  //     slides_url: "https://bit.ly/saadpasta-slides",
  //     event_url: "https://www.facebook.com/events/2339906106275053/"
  //   }
  // ],
  // display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  // title: emoji("Podcast 🎙️"),
  // subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // // Please Provide with Your Podcast embeded Link
  // podcast: [
  //   "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  // ],
  // display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  footerLink: [
    {
      name: "Certificate Link",
      url: "https://www.coursera.org/account/accomplishments/verify/P2HBS3LH3NQJ"
    }
    //  you can add extra buttons here.
  ],
  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My inbox is open.",
  email_address: "adonay.gebremedhin@outlook.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
